
$(document).ready(function() {

  var winW = $(window).width();

  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  $(window).load(function() {
    resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), true);
  });

  $(window).resize(function() {
    resizeHeader($('.barra').outerHeight(), $('header').outerHeight(), $('.infobar').outerHeight(), false);
  });

  $('header .icons li .search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .big-search .cerrar-big-search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .icons li .cart').click(function() {
    $('#minicart').addClass('show');
  });

  $('#minicart .cerrar').click(function() {
    $('#minicart').removeClass('show');
  });

  $('header .show-menu').click(function() {
    $('nav').addClass('show');
  });

  $('header nav .cerrar').click(function() {
    $('nav').removeClass('show');
  });

/**
 * Swiper launcher product-section
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
let thumbsSwiperPro = new Swiper(".mySwiper", {
  spaceBetween: 25,
  // centeredSlides: true,
  centeredSlidesBounds: true,
  slidesPerView: 3,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true
});

let swiperPro = new Swiper(".mySwiper2", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  thumbs: {
    swiper: thumbsSwiperPro,
    autoScrollOffset: 1
  },
});


let thumbsSwiperSlider = new Swiper(".mySwiper-slider", {
  spaceBetween: 30, 
  // centeredSlides: true,
  centeredSlidesBounds: true,
  slidesPerView: 4,
  watchOverflow: true,
  watchSlidesVisibility: true,
  watchSlidesProgress: true
});

let swiperSlider = new Swiper(".mySwiper2-slider", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  thumbs: {
    swiper: thumbsSwiperSlider,
    autoScrollOffset: 1
  },
});

// let swiperPro2 = new Swiper(".mySwiper3", {
//   spaceBetween: 10,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   loop: true,
//   spaceBetween: 25,
//   // centeredSlides: true,
//   centeredSlidesBounds: true,
//   slidesPerView: 1,
//   watchOverflow: true,
//   watchSlidesVisibility: true,
//   watchSlidesProgress: true,
// });

// let thumbsSwiperSlidermini = new Swiper(".mySwiper-mini", {
//   spaceBetween: 10,
//   slidesPerView: 3,
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   loop: true,
//   thumbs: {
//     swiper: swiperPro2,
//     autoScrollOffset: 1
//   },
// });

var swiperMini = new Swiper(".mySwiper-mini", {
  spaceBetween: 10,
  slidesPerView: 3,
  freeMode: true,
  watchSlidesProgress: true,
});
var swiperMain = new Swiper(".mySwiper3", {
  spaceBetween: 10,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: swiperMini,
  },
});



  $('.deon > h3').each(function() {
    $(this).addClass('accor');
    $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
  });

  $('.deon h3').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  // Collection

  if (winW < 830) {
    $('.facets__heading').click(function(){
      $(this).toggleClass('clicked');
      $('.template-collection .facets__disclosure').slideToggle(200);
    });
  }

  // Usar para esconder productos:
  // $('.featured-collection ul .item[data-id="5980345401509"]').remove();
  // $('.featured-collection ul .item[data-id="5980346384549"]').remove();
  // $('.featured-collection ul .item[data-id="5980347859109"]').remove();

  // Pop Up
  $('#popup .cerrar').click(function() {
    $('#popup').removeClass('show');
  });

  if ( winW < 830 ) {
    $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-menu').removeClass('show');
      $(this).parent().children('.sub-menu').toggleClass('show');
    });
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
      $(this).parent().children('.sub-sub-menu').toggleClass('show');
    });
  }

  /**
   * Escucha permanente para agregar productos, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '.item .addcart', function() {
    var proVar = $(this).data('product-id');
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: proVar
      },
      success: function(data) {
      },
      error: function(data) {
        if (data.status == 422) {
          $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
        }
      },
      async: false
    });
    update_mini_cart(true);
  });
});

/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, false);
    updateFreeShippingPrice();
  });
  
});


function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["product_title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var alt        = data.items[i]["featured_image"]["alt"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Cantidad: <span>" + cantidad + "</span></h6></div><div class='right'><img class='lozad' src='" + imagen + "' alt='" + alt + "' loading='lazy' /></div></li>";
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").html('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}

/**
 * Devuelve el stock de la variante seleccionada
 *
 * @param object stock  Inventario de la ariante
 */

 function get_stock(stock = 0) {
   if (stock == 0) {
     $('.remain p').html('Producto agotado');
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == undefined ) {
     $('#sobre-agregar').fadeIn(100);
   } else if (stock == 1) {
     $('.remain p').html('Queda sólo ' + stock + ' unidad');
     $('#sobre-agregar').fadeOut(100);
   } else if (stock > 1 && stock < 6) {
     $('.remain p').html('Quedan sólo ' + stock + ' unidades');
     $('#sobre-agregar').fadeOut(100);
   } else {
     $('.remain p').html('');
     $('#sobre-agregar').fadeOut(100);
   }
 }
 
 /**
  * Agregar días
  * account.liquid
  *
  **/
 
 function addDays(date, days) {
     var result = new Date(date);
     result.setDate(date.getDate() + days);
     return result;
 }
   
 /**
  * Formatear fecha
  * account.liquid
  *
  **/
 
 function formatDate(date) {
     return date.getDate() + '-' + (date.getMonth() + 1) + '-' + date.getFullYear();
 }

/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
function defer(method) {
  if (window.jQuery) {
    method();
  } else {
    setTimeout(function() { defer(method) }, 50);
  }
}

function quantity_elements(ajax = false) {
  if (ajax) {
    $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.product-recommendations .sec-cantidad input');
    $('.product-recommendations .sec-cantidad').each(function() {
      var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });
      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        $(spinner).parent().find(".addcart").data("qt", newVal);
        spinner.find("input").trigger("change");
      });
    });
  } else {
    $('<div class="quantity-nav"><div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div></div>').insertAfter('.sec-cantidad input');
    $('.sec-cantidad').each(function() {
      var spinner = $(this), input = spinner.find('input[type="number"]'), btnUp = spinner.find('.quantity-up'), btnDown = spinner.find('.quantity-down'), min = input.attr('min'), max = input.attr('max');
      btnUp.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });
      btnDown.click(function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        spinner.find("input").val(newVal);
        $(spinner).parent().find(".addcart").data("qt", newVal);
        spinner.find("input").trigger("change");
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    var imageObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var image = entry.target;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function(image) {
      imageObserver.observe(image);
    });
  } else {
    var lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload () {
      if(lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
          if(img.offsetTop < (window.innerHeight + scrollTop)) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
        });
        if(lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
});

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('overflow-hidden-mobile');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove('overflow-hidden-mobile');
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

function resizeHeader(barraH = 0, headerH = 0, infoH = 0, scroll = true) {
  if ( $(window).width() > 830 ) {
    $('body').css('padding-top', barraH );
    $('.template-page').css('padding-top', barraH + headerH );
    $('.template-collection').css('padding-top', barraH + headerH );
    $('.template-404').css('padding-top', barraH + headerH );
    $('.template-search').css('padding-top', barraH + headerH );
    $('.template-blog').css('padding-top', barraH + headerH );
    $('.template-article').css('padding-top', barraH + headerH );
    $('.template-cart').css('padding-top', barraH + headerH );
    $('.template-customers-account').css('padding-top', barraH + headerH );
    $('.template-customers-addresses').css('padding-top', barraH + headerH );
    
    $('header').css('top', barraH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > barraH) {
          $('.barra').addClass('fix');
          $('header').addClass('fix');
          $('header').css('top', barraH);
        } else {
          $('.barra').removeClass('fix');
          $('header').removeClass('fix');
          $('header').css('top', barraH -1);
        }
      });
    } 
  } else {
    $('body').css('padding-top', barraH + headerH);
    $('header').css('top', barraH);
    if (scroll === true) {
      $(window).scroll(function() {
        if ($(window).scrollTop() > barraH) {
          $('.barra').addClass('fix');
          $('header').addClass('fix');
          $('header').css('top', barraH -1);
        } else {
          $('.barra').removeClass('fix');
          $('header').removeClass('fix');
          $('header').css('top', barraH);
        }
      });
    }

    let btnComprar = document.querySelectorAll('.featured-collection ul .item .boton .addcart');

    btnComprar.forEach(btn => {
      btn.innerHTML = '<div><img src="//cdn.shopify.com/s/files/1/0622/0850/8134/t/2/assets/cart.png?v=6234731669667182494"></div>';
    });


/*     document.querySelector('.featured-collection ul .item .boton .addcart').innerHTML = '<div><img src="//cdn.shopify.com/s/files/1/0622/0850/8134/t/2/assets/cart.png?v=6234731669667182494"></div>';
     */
    
  }
}



/* C A L I D A D*/

function buttons() {
  let buttons = document.querySelectorAll('.calidad-group-buttons-container button');
  buttons.forEach(function (button) {
    button.addEventListener('click', (e) => {
      let buttonTarget = e.target;
      buttonTarget.classList.add('button-active');
      let buttonTargetSiblings = buttonTarget.parentNode.querySelectorAll('button');
      buttonTargetSiblings.forEach(function (buttonSibling) {
        if (buttonSibling != buttonTarget) {
          buttonSibling.classList.remove('button-active');
        }
      }
      );

      let buttonTargetContent = (e.target.id).toLowerCase();

      console.log(buttonTargetContent);
      
      let allContent = document.querySelectorAll('.calidad-zona-container');
      

      allContent.forEach(function (content) {
        console.log(content.id);
         if (content.id == buttonTargetContent) {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      }
      );

    })
  })
}

document.onload = buttons();